import {
  CardIcon,
} from 'web-components';

import {
  Flex,
  Text,
} from 'web-styled';

import * as S from './styled';

const Icon = () => (
  <svg
    width="70"
    height="70"
    viewBox="0 0 70 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M55.7812 13.125H14.2188C9.99032 13.125 6.5625 16.5528 6.5625 20.7812V49.2188C6.5625 53.4472 9.99032 56.875 14.2188 56.875H55.7812C60.0097 56.875 63.4375 53.4472 63.4375 49.2188V20.7812C63.4375 16.5528 60.0097 13.125 55.7812 13.125Z"
      stroke="#CCCCCC"
      strokeWidth="4.375"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.5625 26.25H63.4375"
      stroke="#CCCCCC"
      strokeWidth="8.20312"
      strokeLinejoin="round"
    />
    <path
      d="M24.0625 41.0156H17.5V43.75H24.0625V41.0156Z"
      stroke="#CCCCCC"
      strokeWidth="8.20312"
      strokeLinejoin="round"
    />
  </svg>
);

type Props = {
  defaultCardId: String,
  paymentMethods?: any[],
  onDelete: { (method: any): void },
  onSetDefault: { (method: any): void },
};

const CardsList = ({
  defaultCardId,
  paymentMethods = [],
  onDelete,
  onSetDefault,
}: Props) => {
  if (paymentMethods.length == 0) {
    return (
      <Flex column spacing={5} align="center" justify="center">
        <Icon />
        <Text size="18px" color="#CCCCCC">
          Add a credit card using the button below
        </Text>
      </Flex>
    )
  }

  return (
    <>
      {paymentMethods?.map(method => (
        <Flex
          key={method.id}
          justify="space-between"
          width="100%"
          padding="10px"
          align="center"
        >
          <Flex
            spacing={10}
            align="center"
          >
            <CardIcon brand={method.card.brand} />
            <Text>
              {method.card.last4}
              ,
            </Text>
            <Text>
              {method.card.exp_month}
              /
              {method.card.exp_year}
            </Text>
          </Flex>
          <Flex align="center">
            <Text>{method.billing_details?.name}</Text>

            {(paymentMethods.length > 1 && defaultCardId !== method.id) && (
              <S.MakeDefaultButton
                onClick={() => onSetDefault(method)}
              >
                Make Default
              </S.MakeDefaultButton>
            )}

            <S.DeleteButton
              onClick={() => onDelete(method)}
            >
              delete
            </S.DeleteButton>
          </Flex>
        </Flex>
      ))}
    </>
  );
}

export default CardsList;
